import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { SocialProofPopup } from './components/SocialProofPopup';
import { Hero } from './components/Hero';
import { SalesCopy } from './components/SalesCopy';
import { Testimonials } from './components/Testimonials';
import { PurchaseSection } from './components/PurchaseSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-gradient-to-b from-[#0f172a] via-[#1e1b4b] to-[#0f172a] font-sans selection:bg-gold-500/30" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <SocialProofPopup data-id="element-2" />

      <main data-id="element-3">
        <Hero data-id="element-4" />
        <SalesCopy data-id="element-5" />
        <Testimonials data-id="element-6" />
        <PurchaseSection data-id="element-7" />
      </main>

      <Footer data-id="element-8" />
    </div>;
}